import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import MaterialIcon, { Icon } from "src/shared/components/MaterialIcon";

// Omitting the sx prop in favor of an innerSx prop
type PlaybackActionProps = Omit<React.HTMLProps<HTMLDivElement>, "sx"> & {
  icon: Icon;
  innerSx: ThemeUIStyleObject;
};

export default function PlaybackAction({ icon, innerSx, ...props }: PlaybackActionProps) {
  return (
    <div {...props} sx={{ ...lessonCardPlaybackActionStyle, ...innerSx }}>
      <MaterialIcon icon={icon} />
    </div>
  );
}

const lessonCardPlaybackActionStyle: ThemeUIStyleObject = {
  width: "64px",
  height: "64px",
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  borderRadius: "dt_radius_m",
  fontSize: "40px",
  marginLeft: RAW_cssValue("20px"),
  marginRight: RAW_cssValue("20px"),
};
